import { ThemeProvider } from '@emotion/react';

import * as React from 'react';

import requestUrlInfo from 'js/lib/requestUrlInfo';
import { useRouter } from 'js/lib/useRouter';

import { searchTheme } from 'bundles/search-common/searchTheme';
import { getShouldShowBrowseInSERP } from 'bundles/search-common/utils/experimentUtils';
import SearchPageRoot from 'bundles/search-v2/components/SearchPageRoot';
import SEOEntityPage from 'bundles/seo-entity-page/components/SEOEntityPage';
import { SeoSearchProviderWrapper } from 'bundles/seo-entity-page/components/SeoSearchProviderWrapper';
import SeoPathConfigurationQueryWrapper from 'bundles/seo/api/SeoPathConfigurationQueryWrapper';

export const SeoSearchPage = () => {
  const router = useRouter();
  const searchQuery = router.location.query;
  const hasSearchQuery = !!searchQuery.query;
  const { pathname, search } = router.location;
  const hostname = requestUrlInfo().hostname;

  return (
    <SeoPathConfigurationQueryWrapper
      path={hostname + pathname + search}
      shouldNotSkipIfAuthenticated={getShouldShowBrowseInSERP()}
    >
      <ThemeProvider theme={searchTheme}>
        {hasSearchQuery ? (
          <SEOEntityPage />
        ) : (
          <SeoSearchProviderWrapper isSEOEntityPage={hasSearchQuery}>
            <SearchPageRoot />
          </SeoSearchProviderWrapper>
        )}
      </ThemeProvider>
    </SeoPathConfigurationQueryWrapper>
  );
};

export default SeoSearchPage;
